<template>
  <div class="container">
    <div class="header">
      <div class="nav">
        <ul>
          <router-link to="/home"><li class="navLi">首页</li></router-link>
          <router-link to="/about"><li>关于壹创新</li></router-link>
          <router-link to="/contact"><li>联系我们</li></router-link>
        </ul>
      </div>
      <div class="download">
        <img class="logo" src="@/assets/img/LOGO.png" alt="">
        <p class="downloadAPP">下载APP</p>
        <div class="edition">
          <img @mouseover="openApp(1)" @mouseout="openApp(2)" src="@/assets/img/IOS.png" alt="">
          <img @mouseover="openAndroidApp(1)" @mouseout="openAndroidApp(2)" src="@/assets/img/Android.png" alt="">
        </div>
        <img ref="IOSImg" class="IOSImg" src="@/assets/img/homeDownload.jpg" alt="">
        <img ref="AndroidImg" class="AndroidImg" src="@/assets/img/homeDownload.jpg" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
    import bottom from '@/components/bottom.vue'

    export default {
        name: "home",
        components:{bottom},
        data() {
          return {
            className:''
          }
        },
        methods: {
          openApp(val) {
            if(val === 1){
              this.$refs.IOSImg.style.display = 'block';
            }else if(val === 2){
              this.$refs.IOSImg.style.display = 'none';
            }
          },
          openAndroidApp(val) {
            if(val === 1){
              this.$refs.AndroidImg.style.display = 'block';
            }else if(val === 2){
              this.$refs.AndroidImg.style.display = 'none';
            }
          }
        },
    }
</script>

<style scoped>
  .container{
    /*margin-left:auto;*/
    /*margin-right:auto;*/
    /*box-sizing:border-box;*/
    /*width:100%;*/
    /*position:relative;*/
  }
  .header{
    height:910px;
    background:url(../../assets/img/home1920-910.png) no-repeat center center;
    background-size:100% 100%;
    padding-top:25px;
  }
  .nav{
    height:65px;
    margin-right:323px;
  }
  .nav ul{
    height:70px;
    display:flex;
    justify-content:flex-end;
    align-items:center;
  }
  .nav ul li{
    font-size:18px;
    font-family:'PingFang Bold';
    color:#221815;
    font-weight:600;
    padding:13px 35px;
    margin-right:20px;
  }
  .navLi{
    border:1px solid rgba(34, 24, 21, 0.5);
    border-radius:20px;
  }
  .download{
    position:absolute;
    left:379px;
    top:379px;
  }
  .logo{
    width:137px;
    height:137px;
  }
  .downloadAPP{
    font-family:'PingFang Light';
    font-size:40px;
    /*font-weight:500;*/
    color:#221815;
    margin:15px 0 25px 10px;
  }
  .edition{
    margin-left:10px;
  }
  .IOSImg{
    width:150px;
    height:150px;
    position:absolute;
    left:40px;
    bottom:-160px;
    display:none;
  }
  .AndroidImg{
    width:150px;
    height:150px;
    position:absolute;
    right:45px;
    bottom:-160px;
    display:none;
  }
  .edition img{
    width:204px;
    height:60px;
    margin-right:22px;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue